import { Button } from '@/components/ui/Button';
import { usePwaInstall } from '@/hooks/usePwaInstall';
import { isIOS, isStandalonePwa } from '@/lib/serviceWorker';
import styles from './PwaInstallButton.module.css';

/**
 * Wiederverwendbare App-Installations-Karte. Zeigt je nach Plattform:
 *   - Chromium (beforeinstallprompt gefeuert): nativen Install-Button
 *   - iOS-Safari (kein Event): „Zum Home-Bildschirm"-Kurzanleitung
 *   - bereits installiert (standalone): Bestätigungs-Hinweis
 *   - sonst: nichts (z. B. Desktop ohne Install-Support)
 */
export function PwaInstallButton() {
  const pwa = usePwaInstall();
  const ios = isIOS();
  const standalone = isStandalonePwa();

  if (pwa.isInstalled || standalone) {
    return (
      <div className={styles.box}>
        <div className={styles.hint}>📱 App ist installiert.</div>
      </div>
    );
  }

  if (ios) {
    return (
      <div className={styles.box}>
        <div className={styles.title}>📱 App installieren</div>
        <div className={styles.hint}>So fügst du die App zum Home-Bildschirm hinzu:</div>
        <ol className={styles.iosSteps}>
          <li>Unten in Safari auf <strong>Teilen</strong> tippen (das Quadrat mit Pfeil).</li>
          <li><strong>Zum Home-Bildschirm</strong> wählen.</li>
          <li>Die App vom Home-Bildschirm starten.</li>
        </ol>
      </div>
    );
  }

  if (!pwa.canInstall) return null;

  return (
    <div className={styles.box}>
      <div className={styles.title}>📱 App installieren</div>
      <div className={styles.hint}>Schnellerer Start und klassisches App-Erlebnis.</div>
      <div className={styles.actions}>
        <Button variant="secondary" onClick={() => pwa.install()}>
          📱 Als App installieren
        </Button>
      </div>
    </div>
  );
}
